import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import TransactionOverlay from '../../components/transactions/TransactionOverlay';
import PayBillPaymentUpdate from '../payments/PayBillPaymentUpdate';
import type { BillPayment } from '../../types/billPayment';
import { usePurchaseTransactionsHub } from './PurchaseTransactionsHubContext';
import {
  parsePurchaseHubLocationState,
  resolvePaymentAllocationsCloseTarget,
} from './purchaseHubNavigation';

const PurchasePaymentAllocationsOverlay = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { refetchList } = usePurchaseTransactionsHub();
  const listSearch = location.search.replace(/^\?/, '');
  const navState = useMemo(
    () => parsePurchaseHubLocationState(location.state),
    [location.state]
  );

  const parsedId = id != null ? Number(id) : Number.NaN;
  const paymentId = Number.isNaN(parsedId) || parsedId <= 0 ? undefined : parsedId;

  const close = useCallback(() => {
    const target = resolvePaymentAllocationsCloseTarget(paymentId, listSearch, navState);
    navigate(target, { preventScrollReset: true });
  }, [listSearch, navState, navigate, paymentId]);

  const handlePaymentSaved = useCallback(
    (_payment: BillPayment) => {
      refetchList();
      close();
    },
    [close, refetchList]
  );

  return (
    <TransactionOverlay headerless variant="wide" onClose={close}>
      <div className="flex flex-1 min-h-0 flex-col">
        <PayBillPaymentUpdate
          key={paymentId}
          embedded
          paymentId={paymentId}
          onClose={close}
          onPaymentSaved={handlePaymentSaved}
        />
      </div>
    </TransactionOverlay>
  );
};

export default PurchasePaymentAllocationsOverlay;
